import { createContext } from "react";
import { DEVICE_TYPE } from "utils/enum";

export const AppContext = createContext({
  browserName: "",
  deviceType: DEVICE_TYPE.DESKTOP,
});
